//import loggingService from '../services/util/loggingService'

//var serviceName = 'culturalResourceIdentifierService'
var path = '/CulturalResourceIdentifier/'
//var isDebug = false

function put (http, culturalResourceIdentifierDto) {
    return http.put(path, culturalResourceIdentifierDto)
}

function get (http, culturalResourceIdentifierId) {
    return http.get(path + 'Get?culturalResourceIdentifierId=' + culturalResourceIdentifierId)
}

function search (http, searchDto) {
    return http.post(path + 'Search', searchDto)
}

function remove (http, id) {
    return http.post(path + 'Delete?culturalResourceIdentifierId=' + id)
}

export default {
    get: get,
    put: put,
    remove: remove,
    search: search
}



// WEBPACK FOOTER //
// ./src/services/culturalResourceIdentifierService.js